import type { ReactElement } from 'react';
import type { ProposalTheme } from '@shared/types';
import { brandNameFor } from '../lib/theme';

/** Consistent brand mark: the theme's logo when set, brandName text otherwise. */
export function BrandMark({
  theme,
  fallback,
}: {
  theme: ProposalTheme | null | undefined;
  fallback: string;
}): ReactElement {
  const name = brandNameFor(theme, fallback);
  if (theme?.logoUrl) {
    return <img className="brand-mark brand-mark-logo" src={theme.logoUrl} alt={name} />;
  }
  return <span className="brand-mark brand-mark-text">{name}</span>;
}
